import * as React from 'react';
import { SVGProps } from 'react';

const IconSolverSummarySizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm1 14h10v-2.176h-5.845l3.546-4.017-3.26-3.59h4.986V6H7.231v1.548l4.035 4.377L7 16.56V18Z"
      fill="#91C2A6"
    />
  </svg>
);
export default IconSolverSummarySizeM;
